import { IPageLayoutType } from "../../types/pageLayoutTypes";

export const useExploratoryDetails = () => {
  const rowData = [
    {
      id: "EA1001",
      created: "01/05/2024",
      studyID: "ONC-NSCLC-2024-01",
      testName: "Analysis of Biomarkers-PD-L1",
      status: "Created",
      lastupdate: "07/02/2024",
      exploratory_id: "EA1001",
      isNew: true,
    },
    {
      id: "EA1002",
      created: "04/16/2024",
      studyID: "ONC-NSCLC-2024-01",
      testName: "Analysis of Biomarkers-PD-L1",
      status: "Created",
      lastupdate: "06/27/2024",
      exploratory_id: "EA1002",
      isUpdated: true,
    },
    {
      id: "EA1003",
      badge: "",
      created: "04/20/2024",
      studyID: "ONC-NSCLC-2024-01",
      testName: "Analysis of Biomarkers-PD-L1",
      status: "Created",
      lastupdate: "07/02/2024",
      exploratory_id: "EA1003",
    },
    {
      id: "EA1004",
      badge: "",
      created: "04/22/2024",
      studyID: "ONC-NSCLC-2024-01",
      testName: "Analysis of Biomarkers-PD-L1",
      status: "Created",
      lastupdate: "06/27/2024",
      exploratory_id: "EA1004",
    },
    {
      id: "EA1005",
      badge: "",
      created: "04/22/2024",
      studyID: "ONC-NSCLC-2024-01",
      testName: "Analysis of Biomarkers-PD-L1",
      status: "Created",
      lastupdate: "07/14/2024",
      exploratory_id: "EA1005",
    },
  ];
  const exploratoryDetailsContentJson: IPageLayoutType[] = [
    {
      title: "EA Details",
      description: "",
      content: [
        {
          label: "Test Name",
          value: "Analysis of Biomarkers - PD-L1",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Study Name",
          value: "ONC-NSCLC-2024-01",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Sample",
          value: "Chip data, Chip data2",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Expected Date",
          value: "08-01-2024",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Testing Protocol",
          value: "pdflink in chip",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Protocol Name",
          value: "IHC-PD-L1",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Requested by",
          value: "John Deo",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Nome",
          value: "This exploratory test is request by translational science group to discover new biomarkers as surrogate endpoint.",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
      ],
    },
  ];
  const timeLineDetails = [
    {
      step: "Created",
      by: "John Smith",
      date: "01/05/2024 8:00AM",
    },
    {
      step: "Recieved",
      by: "Joe Doe",
      date: "01/06/2024 8:00 AM",
    },
    {
      step: "Initiated",
      by: "Micheal John",
      date: "02/10/2024 8:00 AM",
    },
    {
      step: "Processed",
      by: "Kristen Atte",
      date: "03/15/2024 8:00 AM",
    },
    {
      step: "Staged",
      by: "Flintop Martin",
      date: "04/15/2024 8:00 AM",
    },
    {
      step: "Complete",
      by: "Leonardo Marsh",
      date: "05/15/2024 8:00 AM",
    },
  ];
  return {
    rowData,
    exploratoryDetailsContentJson,
    timeLineDetails,
  };
};
